import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';


export class LayerComponent extends BaseComponent {
    constructor(){
        super();
        this.componentType = ComponentNames.layerComponent;
    }
    id:number;
}